export default function Services() {
  const services = [
    {
      title: 'Microfilm Digitization',
      description: 'High-resolution scanning of 16mm and 35mm microfilm with precise frame-by-frame capture',
      image: 'https://public.readdy.ai/ai/img_res/c7be441d15bb8008afb3c99406be090b.jpg',
      bgColor: 'bg-[#FFE4E1]',
      icon: 'ri-film-line'
    },
    {
      title: 'Microfiche Conversion',
      description: 'Expert conversion of microfiche sheets into searchable digital formats with OCR capabilities',
      image: 'https://readdy.ai/api/search-image?query=Professional%20microfiche%20sheets%20and%20cards%20arranged%20neatly%20on%20clean%20workspace%20with%20modern%20scanning%20equipment%20visible%2C%20showing%20transparent%20film%20cards%20in%20organized%20layout%20with%20soft%20lighting%20and%20minimal%20clutter%2C%20emphasizing%20precision%20digitization%20and%20document%20preservation%20services&width=600&height=800&seq=service-microfiche&orientation=portrait',
      bgColor: 'bg-[#E0F2F1]',
      icon: 'ri-file-list-3-line'
    },
    {
      title: 'Bound Materials',
      description: 'Careful digitization of books, journals, and bound documents with spine-friendly techniques',
      image: 'https://readdy.ai/api/search-image?query=Antique%20leather-bound%20books%20and%20vintage%20journals%20carefully%20positioned%20on%20clean%20surface%20with%20professional%20book%20scanning%20equipment%20nearby%2C%20showing%20heritage%20preservation%20setup%20in%20soft%20natural%20lighting%20with%20minimal%20background%20clutter%2C%20emphasizing%20careful%20handling%20and%20archival%20digitization%20services&width=600&height=800&seq=service-bound&orientation=portrait',
      bgColor: 'bg-[#F5F5F5]',
      icon: 'ri-book-open-line'
    },
    {
      title: 'Legacy Media Formats',
      description: 'Comprehensive solutions for photographs, slides, negatives, and other archival materials',
      image: 'https://readdy.ai/api/search-image?query=Collection%20of%20vintage%20photographs%2C%20photographic%20slides%2C%20and%20film%20negatives%20arranged%20professionally%20on%20clean%20workspace%20showing%20various%20legacy%20media%20formats%2C%20with%20modern%20preservation%20equipment%20visible%20in%20soft%20studio%20lighting%20and%20minimal%20background%2C%20emphasizing%20comprehensive%20digitization%20services&width=600&height=800&seq=service-legacy&orientation=portrait',
      bgColor: 'bg-[#FFF8E1]',
      icon: 'ri-image-2-line'
    }
  ];

  return (
    <section id="services" className="py-24 px-6 bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <span className="text-sm font-semibold text-[#0D9488] uppercase tracking-wide whitespace-nowrap">
            OUR EXPERTISE
          </span>
        </div>

        <div className="mb-16">
          <div className="grid md:grid-cols-2 gap-8 items-start">
            <div>
              <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-[#1E3A8A] leading-tight mb-6">
                Professional
                <br />
                Digitization
                <br />
                Services
              </h2>
            </div>
            <div className="flex flex-col gap-4">
              <div className="w-32 h-32 rounded-full overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Close-up%20view%20of%20vintage%20microfilm%20reels%20with%20warm%20amber%20tones%20in%20professional%20archival%20setting%2C%20showing%20detailed%20texture%20of%20film%20spools%20with%20soft%20studio%20lighting%20and%20minimal%20background%2C%20emphasizing%20heritage%20preservation%20and%20legacy%20media%20digitization%20quality&width=300&height=300&seq=service-icon-1&orientation=squarish" 
                  alt="Microfilm" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-32 h-32 rounded-full overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Close-up%20of%20transparent%20microfiche%20sheets%20with%20cool%20blue%20tones%20in%20modern%20preservation%20laboratory%2C%20showing%20clear%20film%20texture%20and%20professional%20handling%20with%20soft%20ambient%20lighting%20and%20clean%20background%2C%20emphasizing%20precision%20archival%20digitization%20services&width=300&height=300&seq=service-icon-2&orientation=squarish" 
                  alt="Microfiche" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-24 h-24 rounded-lg overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Vintage%20leather-bound%20book%20cover%20with%20aged%20texture%20in%20warm%20natural%20tones%2C%20showing%20detailed%20craftsmanship%20and%20heritage%20materials%20with%20soft%20lighting%20on%20clean%20background%2C%20emphasizing%20careful%20document%20preservation%20and%20archival%20digitization%20expertise&width=300&height=300&seq=service-icon-3&orientation=squarish" 
                  alt="Bound materials" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop>
          {services.map((service, index) => (
            <div 
              key={index} 
              className={`${service.bgColor} rounded-3xl overflow-hidden hover:scale-105 transition-all duration-300 cursor-pointer group`}
              style={{ height: index % 2 === 0 ? '480px' : '520px' }}
            >
              <div className="h-[85%] relative overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title} 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 w-12 h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center">
                  <i className={`${service.icon} text-2xl text-[#1E3A8A]`}></i>
                </div>
              </div>
              <div className="h-[15%] bg-white px-6 flex flex-col justify-center">
                <h3 className="font-bold text-[#1E3A8A] text-base whitespace-nowrap overflow-hidden text-ellipsis">{service.title}</h3>
                <p className="text-xs text-gray-600 mt-1 line-clamp-2">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
